import { httpClient } from '../http/httpClient'

export interface MaritalStatus {
  id: number
  nome: string
  exigeConjuge: boolean
}

export interface MaritalStatusResponse {
  data: MaritalStatus[]
}

export async function getMaritalStatus() {
  const { data } = await httpClient.get<MaritalStatusResponse>(
    '/self-hire/context/estadoCivil',
  )
  return data
}
